import CardOfTheDaySingle from "@/components/CardOfTheDaySingle";
import Loading from "@/components/Loading";
import SubstackModal2 from "@/components/SubstackModal2";
import { apiUrl } from "@/constants";
import { Songcard } from "@/types";
import {
  Card,
  Center,
  Container,
  Divider,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

interface CardProp {
  id: number;
  card: Songcard;
}

export default function CardOfTheDay() {
  const [data, setData] = useState<CardProp>();
  const [loadingCards, setLoadingCards] = useState(true);
  const { colorMode } = useColorMode();
  const [theRest, setTheRest] = useState<CardProp[]>();

  const fetchData = async () => {
    try {
      const response = await fetch(`${apiUrl}/card-of-the-day/`);
      const jay = await response.json();
      const thedata = jay;
      setData(thedata);
      setTheRest(thedata.the_rest);
      setLoadingCards(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Head>
        <title>Card Of The Day | Songcards</title>
        <meta property="og:site_name" content="Songcards" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href="https://songcards.io/cotd" />
        <meta name="description" content="Listen. Discover. Collect." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" href="/icon.png" />
        <link rel="icon" href="/songcards.png" />

        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/cotd" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Songcards" />
        <meta property="og:title" content="Card Of The Day | Songcards" />
        <meta property="og:description" content="Listen. Discover. Collect." />
        <meta name="twitter:domain" content="songcards.io" />
        <meta name="twitter:site" content="@unlockyoursound" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Card Of The Day | Songcards" />
        <meta name="twitter:description" content="Listen. Discover. Collect." />

        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <meta name="apple-itunes-app" content="app-id=6737206374" />
      </Head>
      <Center>
        <Heading>Card Of The Day</Heading>
      </Center>
      <br />
      <Center>
        <Text>Your daily dose</Text>
      </Center>
      <br />
      {!loadingCards && data && (
        <>
          <Center>
            <CardOfTheDaySingle item={data} />
          </Center>
          <br />
          <br />
          <br />
          <Container w={300}>
            <Divider />
          </Container>
          <br />
          <br />
          <Center>
            <Heading>Previous Editions</Heading>
          </Center>
          <br />
          {theRest &&
            theRest.map((card: CardProp) => (
              <>
                <Center mt={5} mb={5}>
                  <Link href={`/cards/${card.card.uuid}`}>
                    <Card
                      maxW="xs"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      bgColor={colorMode === "dark" ? "black" : "white"}
                      variant="outline"
                      borderColor={colorMode === "dark" ? "white" : "black"}
                      borderStyle="dotted"
                      height="50px"
                      width="300px"
                      textAlign="center"
                    >
                      <Text>{card.card.title}</Text>
                    </Card>
                  </Link>
                </Center>
              </>
            ))}
          <br />
          <br />
          <SubstackModal2 />
          <Center mb={300} mt={20}>
            <Link href="/">
              <Image
                src={
                  colorMode === "dark"
                    ? "/SC Icon_B_White.svg"
                    : "/SC Icon_B_Black.svg"
                }
                width={30}
                height={30}
                alt="Discover more Songcards"
              />
            </Link>
          </Center>
        </>
      )}

      {loadingCards && <Loading />}
    </div>
  );
}
